export const phaseMapper: {[key: string]: string} = {
  main: 'Υποβολές',
  extra: 'Συμπληρωματικά Έγγραφα',
  evaluation: 'Αξιολόγηση',
  evaluationBoard: 'Επιτροπή Αξιολόγησης',
  requestModification: 'Αίτημα Τροποποίησης',
  requestModificationEvaluation: 'Αξιολόγηση Αιτήματος',
  requestAid: 'Αίτημα Καταβολής Ενίσχυσης (Ελέγχου)', 
  verificationReport: 'Έκθεση Επαλήθευσης (Ελέγχου)', 
  certificationReport: 'Έκθεση Πιστοποίησης',
  aidPayment: 'Καταβολή Ενίσχυσης (Εκταμίευση)',
  excelValues: 'Excel Τιμές',
  chatGPTValues: 'Απαντήσεις Chat GPT'
};
export const queueMapper: {[key: string]: string} = {
  pdfQueue: 'Χρονοδιάγραμμα',
  sectionEQueue: 'Συμπαραγωγοί',
  accountantQueue: 'Ορκωτοί Λογιστές',
  requestAidQueue: 'Τεχνική Αναφορά'
};

export const queueJsons: {[key: string]: any} = {
  pdfQueue: {
    startWork: null,
    endWork: null,
    startShooting: null,
    endShooting: null,
    shootingDays: null,
    numberOfEmployees: null,
    shootingLocation: null,
  },
  sectionEQueue: [
    {"co-producer": ''},    
  ],
  accountantQueue: {
    accountant: null
  },
  requestAidQueue: {
    startWork: null,
    endWork: null,
    startShooting: null,
    endShooting: null,
    shootingDays: null,
    numberOfEmployees: null,
    shootingLocation: null,
  },
  excelValues: {
    "ΣΥΝΟΛΙΚΟΣ ΑΠΟΛΟΓΙΣΜΟΣ": {
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ (ELIGIBLE EXPENSES)": null,
      "ΣΥΝΟΛΙΚΕΣ ΥΛΟΠΟΙΗΜΕΝΕΣ ΔΑΠΑΝΕΣ (TOTAL IMPLEMENTED EXPENSES)": null,
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (ELIG. NON-RESIDENTIAL EXPENSES)": null,
      "ΥΛΟΠΟΙΗΜΕΝΕΣ ΕΠΙΛ. ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (IMPLEM. ELIG. NON-RESIDENTIAL EXPENSES)": null,
    },
    "1. ΑΜΟΙΒΕΕΣ ΣΕΝΑΡΙΟΓΡΑΦΟΥ, ΣΚΗΝΟΘΕΕΤΗ, ΠΑΡΑΓΩΓΟΥ ΚΑΙ ΑΜΟΙΒΕΣ ΓΙΑ ΠΝΕΥΜΑΤΙΚΑ ΔΙΚΑΙΩΑΜΑΤΑ ΜΟΥΣΙΚΗΣ ΕΠΕΝΔΥΣΗΣ (άρθρο 38 παρ.1 Ν.4821/2021, ΦΕΚ Α 134/31.07.2021) (INTELLECTUAL PROPERTY RIGHTS)": {
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ (ELIGIBLE EXPENSES)": null,
      "ΣΥΝΟΛΙΚΕΣ ΥΛΟΠΟΙΗΜΕΝΕΣ ΔΑΠΑΝΕΣ (TOTAL IMPLEMENTED EXPENSES)": null,
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (ELIG. NON-RESIDENTIAL EXPENSES)": null,
      "ΥΛΟΠΟΙΗΜΕΝΕΣ ΕΠΙΛ. ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (IMPLEM. ELIG. NON-RESIDENTIAL EXPENSES)": null,
    },
    "2. ΑΜΟΙΒΕΣ ΣΥΝΕΡΓΕΙΟΥ, ΗΘΟΠΟΙΩΝ & ΕΚΤΕΛΕΣΤΗ ΠΑΡΑΓΩΓΗΣ (CAST, CREW &  PRODUCTION SERVICES)": {
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ (ELIGIBLE EXPENSES)": null,
      "ΣΥΝΟΛΙΚΕΣ ΥΛΟΠΟΙΗΜΕΝΕΣ ΔΑΠΑΝΕΣ (TOTAL IMPLEMENTED EXPENSES)": null,
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (ELIG. NON-RESIDENTIAL EXPENSES)": null,
      "ΥΛΟΠΟΙΗΜΕΝΕΣ ΕΠΙΛ. ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (IMPLEM. ELIG. NON-RESIDENTIAL EXPENSES)": null,
    },
    "3. ΣΧΕΔΙΑΣΜΟΣ & ΥΛΟΠΟΙΗΣΗ ΠΑΡΑΓΩΓΗΣ (PRODUCTION DESIGN & IMPLEMENTATION)": {
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ (ELIGIBLE EXPENSES)": null,
      "ΣΥΝΟΛΙΚΕΣ ΥΛΟΠΟΙΗΜΕΝΕΣ ΔΑΠΑΝΕΣ (TOTAL IMPLEMENTED EXPENSES)": null,
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (ELIG. NON-RESIDENTIAL EXPENSES)": null,
      "ΥΛΟΠΟΙΗΜΕΝΕΣ ΕΠΙΛ. ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (IMPLEM. ELIG. NON-RESIDENTIAL EXPENSES)": null,
    },
    "4. ΤΕΧΝΙΚΟΣ ΕΞΟΠΛΙΣΜΟΣ (TECHNICAL EQUIPMENT)": {
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ (ELIGIBLE EXPENSES)": null,
      "ΣΥΝΟΛΙΚΕΣ ΥΛΟΠΟΙΗΜΕΝΕΣ ΔΑΠΑΝΕΣ (TOTAL IMPLEMENTED EXPENSES)": null,
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (ELIG. NON-RESIDENTIAL EXPENSES)": null,
      "ΥΛΟΠΟΙΗΜΕΝΕΣ ΕΠΙΛ. ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (IMPLEM. ELIG. NON-RESIDENTIAL EXPENSES)": null,
    },
    "5. ΤΑΞΙΔΙΑ, ΔΙΑΜΟΝΗ, ΔΙΑΤΡΟΦΗ (TRAVEL, ACCOMMODATION, CATERING)": {
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ (ELIGIBLE EXPENSES)": null,
      "ΣΥΝΟΛΙΚΕΣ ΥΛΟΠΟΙΗΜΕΝΕΣ ΔΑΠΑΝΕΣ (TOTAL IMPLEMENTED EXPENSES)": null,
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (ELIG. NON-RESIDENTIAL EXPENSES)": null,
      "ΥΛΟΠΟΙΗΜΕΝΕΣ ΕΠΙΛ. ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (IMPLEM. ELIG. NON-RESIDENTIAL EXPENSES)": null,
    },
    "6. ΜΟΝΤΑΖ - ΕΠΕΞΕΡΓΑΣΙΑ (EDITING - POST PRODUCTION)": {
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ (ELIGIBLE EXPENSES)": null,
      "ΣΥΝΟΛΙΚΕΣ ΥΛΟΠΟΙΗΜΕΝΕΣ ΔΑΠΑΝΕΣ (TOTAL IMPLEMENTED EXPENSES)": null,
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (ELIG. NON-RESIDENTIAL EXPENSES)": null,
      "ΥΛΟΠΟΙΗΜΕΝΕΣ ΕΠΙΛ. ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (IMPLEM. ELIG. NON-RESIDENTIAL EXPENSES)": null,
    },
    "7. ΛΟΙΠΕΣ ΔΑΠΑΝΕΣ (OTHER EXPENSES)": {
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ (ELIGIBLE EXPENSES)": null,
      "ΣΥΝΟΛΙΚΕΣ ΥΛΟΠΟΙΗΜΕΝΕΣ ΔΑΠΑΝΕΣ (TOTAL IMPLEMENTED EXPENSES)": null,
      "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (ELIG. NON-RESIDENTIAL EXPENSES)": null,
      "ΥΛΟΠΟΙΗΜΕΝΕΣ ΕΠΙΛ. ΑΛΛΟΔΑΠΕΣ ΔΑΠΑΝΕΣ (IMPLEM. ELIG. NON-RESIDENTIAL EXPENSES)": null,
    }
  }
};